import { Button, CircularProgress } from '@material-ui/core';

import { IButtonWithLoadingProps } from './types';

const ButtonWithLoading = ({
  isLoading,
  children,
  ...buttonProps
}: IButtonWithLoadingProps) => {
  return (
    <Button {...buttonProps} disabled={isLoading || buttonProps?.disabled}>
      {isLoading ? <CircularProgress color="inherit" size={24} /> : children}
    </Button>
  );
};

export default ButtonWithLoading;
